<template>
  <div :class="['table-skeleton', { 'no-animation': !isShowSkeleton }]">
    <template v-for="i in tableSkeletonRows" :key="i">
      <div class="table-skeleton-all">
        <div class="checkout-expandIcon" :style="{ width: checkedParams.enabled && expandIcon ? checkedParams.width + 32 + 'px' : checkedParams.enabled && !expandIcon ? checkedParams.width + 'px' : !checkedParams.enabled && expandIcon ? '32px' : '0px' }"></div>
        <div :class="[item.children?.length ? 'table-skeleton-child' : 'table-skeleton-item']" :style="{ width: item?.width + 'px' }" v-for="item in props.tableColumns" :key="item.colKey">
          <template v-if="item.children?.length">
            <div class="table-skeleton-child-item" :style="{ width: child?.width + 'px' }" v-for="child in item.children" :key="child.colKey"></div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { onBeforeUnmount, ref } from 'vue';

const props = defineProps({
  tableColumns: {
    type: Array,
    default: () => []
  },
  tableSkeletonRows: {
    type: Number,
    default: 10
  },
  expandIcon: {
    type: [Boolean, String],
    default: false
  },
  checkedParams: {
    type: Object,
    default: () => ({
      enabled: true,
      type: 'checkbox',
      width: 40
    })
  }
});

const isShowSkeleton = ref(true);

onBeforeUnmount(() => {
  isShowSkeleton.value = false;
});
</script>

<style scoped lang="less">
@import './qf-skeleton.less';
</style>
